'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _base = require('../base');

var _base2 = _interopRequireDefault(_base);

var _popover = require('../popover');

var _popover2 = _interopRequireDefault(_popover);

var _mixin = require('../../helpers/util/mixin');

var _mixin2 = _interopRequireDefault(_mixin);

var _addClass = require('../../helpers/dom/add-class');

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = require('../../helpers/dom/remove-class');

var _removeClass2 = _interopRequireDefault(_removeClass);

var _makeElement = require('../../helpers/dom/make-element');

var _makeElement2 = _interopRequireDefault(_makeElement);

var _messaging = require('../../mixins/messaging');

var _messaging2 = _interopRequireDefault(_messaging);

var _validation = require('../../mixins/validation');

var _validation2 = _interopRequireDefault(_validation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * # Card Security Code Input
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * An input container for payment security code details.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @example
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * new Spark.Payments.CardSecurityCode(el, {...});
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @module components/payments/card-security-code.js
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var onValidEvent = document.createEvent('Event');
var onInvalidEvent = document.createEvent('Event');

onValidEvent.initEvent('valid', true, true);
onInvalidEvent.initEvent('invalid', true, true);

var CardSecurityCode = function (_BaseComponent) {
  _inherits(CardSecurityCode, _BaseComponent);

  /**
   * CardSecurityCode constructor.
   * @param {Element} el
   * @param {Object} params
   */
  function CardSecurityCode(el) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, CardSecurityCode);

    var _this = _possibleConstructorReturn(this, _BaseComponent.call(this, el, params));

    _this._bindEventListenerCallbacks();
    _this._addEventListeners();
    return _this;
  }

  /**
   * Sets up references
   * @param {Element} el base DOM element
   * @param {Object} params
   */


  CardSecurityCode.prototype._cacheElements = function _cacheElements(el, params) {
    this.el = el;
    this.inputEl = el ? el.querySelector('input') : undefined;

    if (params.info) {
      this.infoPopoverEl = document.querySelector(params.info);
    }

    if (!this.el || !this.inputEl) {
      throw new Error('SecurityCode markup missing');
    } else {
      if (this.inputEl.value) {
        (0, _addClass2.default)(this.el, 'active');
      }

      if (this.infoPopoverEl) {
        var existingInfoButton = this.el.querySelector('.spark-payment__info--toggle');

        if (existingInfoButton) {
          this.infoEl = existingInfoButton;
        } else {
          this.infoEl = (0, _makeElement2.default)('<button class="spark-payment__info--toggle spark-icon-question-mark-circle spark-icon--md"></button>');
          this.el.appendChild(this.infoEl);
        }

        this.infoPopover = new _popover2.default(this.infoPopoverEl, {
          anchorX: 'center',
          anchorY: 'bottom',
          toggleEl: this.infoEl,
          onOpen: function () {
            (0, _addClass2.default)(this.infoEl, 'spark-icon--fill');
          }.bind(this),
          onClose: function () {
            (0, _removeClass2.default)(this.infoEl, 'spark-icon--fill');
            this.infoEl.focus();
          }.bind(this)
        });
      }

      this.messageEl = this.el.querySelector('.spark-input__message') || (0, _makeElement2.default)('<span class="spark-input__message"></span>');
    }
  };

  /**
   * Create bound versions of event listener callbacks and store them.
   * Otherwise we can't unbind from these events later because the
   * function signatures won't match.
   */


  CardSecurityCode.prototype._bindEventListenerCallbacks = function _bindEventListenerCallbacks() {
    this._onBlurBound = this._onBlur.bind(this);
    this._onFocusBound = this._onFocus.bind(this);
    this._onInputBound = this._onInput.bind(this);
    this._onInfoBound = this._onInfo.bind(this);
    this._onInvalidBound = this._onInvalid.bind(this);
    this._onValidBound = this._onValid.bind(this);
  };

  /**
   * Add event listeners for DOM events.
   */


  CardSecurityCode.prototype._addEventListeners = function _addEventListeners() {
    this.inputEl.addEventListener('input', this._onInputBound, false);
    this.inputEl.addEventListener('blur', this._onBlurBound, false);
    this.inputEl.addEventListener('focus', this._onFocusBound, false);
    this.inputEl.addEventListener('invalid', this._onInvalidBound, false);
    this.inputEl.addEventListener('valid', this._onValidBound, false);

    if (this.infoEl) {
      this.infoEl.addEventListener('click', this._onInfoBound, false);
      this.infoEl.addEventListener('blur', this._onInfoBlurBound, false);
    }
  };

  /**
   * Remove event listeners for DOM events..
   */


  CardSecurityCode.prototype._removeEventListeners = function _removeEventListeners() {
    this.inputEl.removeEventListener('input', this._onInputBound, false);
    this.inputEl.removeEventListener('blur', this._onBlurBound, false);
    this.inputEl.removeEventListener('focus', this._onFocusBound, false);
    this.inputEl.removeEventListener('invalid', this._onInvalidBound, false);
    this.inputEl.removeEventListener('valid', this._onValidBound, false);

    if (this.infoEl) {
      this.infoEl.removeEventListener('click', this._onInfoBound, false);
      this.infoEl.removeEventListener('blur', this._onInfoBlurBound, false);
    }
  };

  /**
   * Getter for Primary Component Value
   * @return {String}
   */


  /**
   * onBlur callback, for controlling component active state, firing provided callbacks, and running validation
   */
  CardSecurityCode.prototype._onBlur = function _onBlur() {
    if (!this.value) {
      this.hide();
    }

    this.onBlur.call(this);

    if (this.inputEl.hasAttribute('data-novalidate')) {
      this.inputEl.removeAttribute('data-novalidate');
    }

    if (!this.valid) {
      this.inputEl.dispatchEvent(onInvalidEvent);
    }
  };

  /**
   * onFocus callback, for controlling component active state and firing provided callbacks
   */


  CardSecurityCode.prototype._onFocus = function _onFocus() {
    this.show();
    this.onFocus.call(this);
  };

  /**
   * onInput callback, for controlling component active state, firing provided callbacks, and running validation
   */


  CardSecurityCode.prototype._onInput = function _onInput() {
    this.value = this.toString().replace(/\D/g, '');

    if (this.value) {
      this.show();
    }

    this.onInput.call(this);

    if (this.inputEl.hasAttribute('data-novalidate')) {
      return;
    } else {
      var validityEvent = this.valid ? onValidEvent : onInvalidEvent;
      this.inputEl.dispatchEvent(validityEvent);
    }
  };

  /**
   * onInfo callback, fired when optional info button addon is interacted with
   * either fires callback method, or displays popover
   * @param {Object} e
   */


  CardSecurityCode.prototype._onInfo = function _onInfo(e) {
    e.preventDefault();
    e.stopPropagation();

    if (this.infoPopover) {
      this.infoPopover.open({
        affixTo: this.infoEl
      });
    }
  };

  /**
   * onInvalid method for firing provided callbacks
   */


  CardSecurityCode.prototype._onInvalid = function _onInvalid() {
    this.onInvalid.call(this);
  };

  /**
   * onValid method for firing provided callbacks
   */


  CardSecurityCode.prototype._onValid = function _onValid() {
    this.onValid.call(this);
  };

  /**
   * Method for triggering focus on component's input element from outside of component
   */


  CardSecurityCode.prototype.focus = function focus() {
    this.inputEl.focus();
  };

  /**
   * Returns a string equivilent to the currently visible value of the input
   * @return {String}
   */


  CardSecurityCode.prototype.toString = function toString() {
    return this.inputEl.value;
  };

  /**
   * Default validate function. This can be overridden by passing a
   * custom validate method as a parameter.
   */


  CardSecurityCode.prototype.validate = function validate() {
    if (this.validatePattern) {
      this.inputEl.setAttribute('pattern', this.validatePattern);
    }

    this.onValidate(this.valid, this.value, this);

    return this;
  };

  /**
   * Show the input by adding the active state and setting character counts (if necessary).
   */


  CardSecurityCode.prototype.show = function show() {
    (0, _addClass2.default)(this.el, 'active');
    return this;
  };

  /**
   * Hide the input by removing the active state.
   */


  CardSecurityCode.prototype.hide = function hide() {
    (0, _removeClass2.default)(this.el, 'active');
    return this;
  };

  /**
   * Set the value of the input.
   * @param {Mixed} value
   */


  CardSecurityCode.prototype.setValue = function setValue(value) {
    this.value = value;

    if (value) {
      this.show();
    } else {
      this.hide();
    }

    return this;
  };

  /**
   * Get the value of the input.
   * @return {String}
   */


  CardSecurityCode.prototype.getValue = function getValue() {
    return this.value;
  };

  /**
   * Clear the value of the input.
   */


  CardSecurityCode.prototype.clearValue = function clearValue() {
    this.value = '';
    return this;
  };

  /**
   * Disable the input.
   */


  CardSecurityCode.prototype.disable = function disable() {
    this.inputEl.attributes.setNamedItem(document.createAttribute('disabled'));
    return this;
  };

  /**
   * Enable the input.
   */


  CardSecurityCode.prototype.enable = function enable() {
    this.inputEl.removeAttribute('disabled');
    return this;
  };

  /**
   * Remove component from DOM.
   * @param {Boolean} leaveElement
   */


  CardSecurityCode.prototype.remove = function remove(leaveElement) {
    return _BaseComponent.prototype.remove.call(this, leaveElement);
  };

  /**
   * Update the element in use and the position.
   * @param {Element} el
   */


  CardSecurityCode.prototype.update = function update(el) {
    return _BaseComponent.prototype.update.call(this, el);
  };

  _createClass(CardSecurityCode, [{
    key: 'value',
    get: function get() {
      return this.inputEl ? this.inputEl.value : undefined;
    }

    /**
     * Setter for Primary Component Value
     * @param {Number} val
     */
    ,
    set: function set(val) {
      if (this.inputEl) {
        if (!isNaN(val)) {
          (0, _addClass2.default)(this.el, 'active');
          this.inputEl.value = val;
        } else if (val === '' || val === undefined || val === null) {
          (0, _removeClass2.default)(this.el, 'active');
          this.inputEl.value = '';
        }
      }
    }

    /**
     * Allows adjustment of max length externaly, so that as card types are recognized by number,
     * this input may be updated to reflect the correct CVV length
     * @param {Number} length
     */

  }, {
    key: 'maxLength',
    set: function set(length) {
      this.inputEl.maxLength = length && length >= 3 && length <= 4 ? length : 4;
    }

    /**
     * Getter for Valid state, returns true if component value is valid, false if not
     * @return {Boolean}
     */

  }, {
    key: 'valid',
    get: function get() {
      return this.inputEl.willValidate && this.inputEl.value.length >= this.inputEl.getAttribute('minlength') && this.inputEl.value.length <= this.inputEl.getAttribute('maxlength');
    }
  }]);

  return CardSecurityCode;
}(_base2.default);

/**
 * Whitelisted parameters which can be set on construction.
 * @type {Array}
 */


CardSecurityCode.prototype._whitelistedParams = ['onInput', 'onBlur', 'onFocus', 'onInvalid', 'onValid', 'validate', 'onValidate', 'validatePattern'];

/**
 * Default values for internal properties we will be setting.
 * These are set on each construction so we don't leak properties
 * into the prototype chain.
 * @type {Object}
 */
CardSecurityCode.prototype.defaults = {
  el: null,
  inputEl: null,
  validatePattern: null,
  validate: null,
  onInput: function onInput() {},
  onBlur: function onBlur() {},
  onFocus: function onFocus() {},
  onInvalid: function onInvalid() {},
  onValid: function onValid() {},
  onValidate: function onValidate() {}
};

(0, _mixin2.default)(CardSecurityCode.prototype, _messaging2.default, _validation2.default);

exports.default = CardSecurityCode;
module.exports = exports['default'];
//# sourceMappingURL=card-security-code.js.map



//////////////////
// WEBPACK FOOTER
// ./~/sabre-spark/js/dist/components/payments/card-security-code.js
// module id = 400
// module chunks = 0